import type { PillTone } from '@/components/ui/pill'

export type RideStatus =
  | 'SEARCHING'
  | 'ACCEPTED'
  | 'ARRIVED'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'NO_DRIVER_FOUND'

/** Valeur spéciale du filtre : raccourci « courses actives » (côté API aussi). */
export type StatusFilter = RideStatus | 'active'

export interface RideHistoryItem {
  id: string
  status: RideStatus
  passengerName: string
  passengerPhone: string | null
  driverName: string | null
  driverPhone: string | null
  estimatedDistanceKm: number
  price: number
  createdAt: string
}

export interface RideHistoryListResponse {
  data: RideHistoryItem[]
  total: number
  page: number
  limit: number
}

/** Filtres bruts lus depuis l'URL (tous optionnels). */
export interface RidesFilters {
  status?: StatusFilter
  from?: string
  to?: string
  driverId?: string
  passengerId?: string
  page: number
  limit: number
}

export const PAGE_SIZES = [10, 25, 50] as const

/** Libellé FR + tonalité de pastille par statut. */
export const STATUS_META: Record<RideStatus, { label: string; tone: PillTone }> = {
  SEARCHING: { label: 'Recherche', tone: 'neutral' },
  ACCEPTED: { label: 'Acceptée', tone: 'primary' },
  ARRIVED: { label: 'Arrivé', tone: 'primary' },
  IN_PROGRESS: { label: 'En course', tone: 'primary' },
  COMPLETED: { label: 'Terminée', tone: 'success' },
  CANCELLED: { label: 'Annulée', tone: 'danger' },
  NO_DRIVER_FOUND: { label: 'Aucun chauffeur', tone: 'danger' },
}

/** Options du sélecteur de statut, dans l'ordre d'affichage. */
export const STATUS_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: 'active', label: 'Actives' },
  { value: 'SEARCHING', label: 'Recherche' },
  { value: 'ACCEPTED', label: 'Acceptée' },
  { value: 'ARRIVED', label: 'Arrivé' },
  { value: 'IN_PROGRESS', label: 'En course' },
  { value: 'COMPLETED', label: 'Terminée' },
  { value: 'CANCELLED', label: 'Annulée' },
  { value: 'NO_DRIVER_FOUND', label: 'Aucun chauffeur' },
]
